export const enum MessageType {
  Primary = 'primary',
  Warning = 'warning',
  Error = 'error',
  Success = 'success',
}
export interface ShowParams {
  type?: MessageType;
  text: string;
  timeout?: number;
}
const message = (params: ShowParams) => {
}

export default message;